import PlayerInterface from "../Interfaces/PlayerInterface";
import GameInterface from "../Interfaces/GameInterface";
import PortalInterface from "../Interfaces/PortalInterface";
import MapInterface from "../Interfaces/MapInterface";
import ScoreInterface from "../Interfaces/ScoreInterface";

import axios from 'axios';
import Fauci from "./Fauci";
import HelperInterface from "../Interfaces/HelperInterface";

export default class Game implements GameInterface
{

    board: HTMLElement;
    player: PlayerInterface;
    portal: PortalInterface;
    levels: Array<MapInterface> = [];
    elements: Array<HTMLElement> = [];
    container: HTMLElement;
    score: ScoreInterface;
    helper: HelperInterface;

    level: number = 0;

    api_key: string;
    api_hash: string;
    high_score: string;

    constructor(player: PlayerInterface, portal: PortalInterface, score: ScoreInterface, container: HTMLElement, helper: HelperInterface)
    {
        this.player = player;
        this.portal = portal;
        this.score = score;
        this.container = container;
        this.helper = helper;

        this.elements.push(portal.render());
        this.player.setGame(this);
        this.portal.setGame(this);
        this.board = document.createElement('div');
        this.board.appendChild(this.player.render());
        this.board.appendChild(this.score.render());
        this.board.appendChild(this.helper.render());

        this.helper.say('Go to the door to begin.')

        this.elements.forEach(eles => {
            this.board.appendChild(eles);
        });
        this.listener();
        this.load_api();
    }

    render(): HTMLElement
    {
        return this.board;
    }

    load()
    {
        if(this.container.childNodes.length > 0) {
            this.container.removeChild(this.container.childNodes[0]);
        }

        this.container.appendChild(this.board);
    }

    addLevel(map: MapInterface)
    {
        this.levels.push(map);
        map.setGame(this);
    }

    loadNextLevel()
    {
        this.elements = [];
        this.elements.push(this.player.render());
        this.elements.push(this.score.render());

        this.score.increaseMultiplier();

        this.elements.push(this.levels[this.level].render());
        this.level++;

        this.score.activate();

        this.board = document.createElement('div');
        this.board.id = 'Board';
        this.elements.forEach(eles => {
            this.board.appendChild(eles);
        });

        this.load();

    }

    listener(): void
    {
        document.getElementById('Game').addEventListener('GameOver', () => {
            this.score.deactivate();
            this.gameover();
        });
    }

    gameover(): void
    {
        // Send score to API.
        const messagePromise = this.digestMessage(this.api_hash + this.score.score.toString());

        messagePromise.then(msg => {
            let payload = {
                key: this.api_key,
                score: this.score.score.toString(),
                signature: msg
            };
            axios.post('https://levi.lol/api/game/score', payload)
            .then(res => {
                console.log(res);
            })
            .catch(err => {
                console.log(err);
            })
            ;
        })

        let modal = document.createElement('div');
        modal.id = 'GameOverModal';

        let modalContent = document.createElement('div');
        modalContent.classList.add('ModalContent');

        let modalHeader = document.createElement('div');
        modalHeader.classList.add('ModalContentHeader');

        let modalContentBody = document.createElement('div');
        modalContentBody.classList.add('ModalContentBody');

        this.high_score = this.score.high_score.toString();
        if(this.score.score > this.score.high_score) {
            this.high_score = this.score.score.toString();
        }

        modalContentBody.appendChild(
            document.createTextNode(
                'Clock: '
                +
                this.score.time.toString()
                +
                ' '
                +
                'Score: '
                +
                this.score.score.toString()
                +
                ' '
                +
                'High Score:'
                +
                ' '
                +
                this.high_score
            )
        )

        let modalHeaderText = document.createTextNode('Game Over');

        modalHeader.appendChild(modalHeaderText);
        modalContent.appendChild(modalHeader);
        modalContent.appendChild(modalContentBody);
        modal.appendChild(modalContent);

        let game = document.getElementById('Game');
        game.appendChild(modal);
    }

    load_api(): void
    {
        axios.get('https://levi.lol/api/game/key')
            .then(res => {
                this.api_key = res.data.key;
                this.api_hash = res.data.hash;
            })
            .catch(err => {
                console.error(err);
            });

    }

     async digestMessage(message) {
        const msgUint8 = new TextEncoder().encode(message);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        // @ts-ignore
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    }
}
